import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WashBooking } from "../../types/admin/washBookings.types";
import { WASH_STATUS_STYLES } from "../../utils/statusButtonStyleSelectors";

export const WashBookingsList = ({
  washBookings,
  setSearchParam,
}: {
  washBookings: WashBooking[];
  setSearchParam: (params: Record<string, string>) => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className="mt-10">
      <h2 className="text-lg font-semibold mb-4">{t("My Bookings")}</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {washBookings.length ? (
          washBookings.map((booking) => {
            const statusStyle = WASH_STATUS_STYLES[booking.status];

            return (
              <div
                key={booking._id}
                onClick={() => setSearchParam({ bookingId: booking._id })}
                className="p-4 rounded-lg bg-primaryBg dark:bg-primaryBgDark cursor-pointer hover:shadow-md transition"
              >
                <div className="flex justify-between items-start mb-3">
                  <span
                    className={`text-xs px-3 py-1 rounded-full font-medium ${statusStyle.className}`}
                  >
                    {statusStyle.label}
                  </span>
                </div>

                <p className="text-sm">
                  <span className="font-medium">{t("Date")}:</span>{" "}
                  {booking.date.split("T")[0]}
                </p>
                <p className="text-sm">
                  <span className="font-medium">{t("Slot")}:</span>{" "}
                  {booking.slotTime}
                </p>
                <p className="text-sm">
                  <span className="font-medium">{t("Price")}:</span> ₹
                  {booking.price}
                </p>
              </div>
            );
          })
        ) : (
          <div className="col-span-2 text-center">{t("No bookings found")}</div>
        )}
      </div>
    </div>
  );
};
